// Package Imports
import { useCallback, useState } from "react";

export const useVerificationOTP = () => {
  const [OTP, setOTP] = useState("");

  const handleSetOTP = useCallback((value) => {
    setOTP(value)
  }, [])

  return {
    OTP,
    handleSetOTP
  }
}
